import React, { useEffect } from "react";
import { Divider, Grid } from "@mui/material";
import EASelectInput from "../../../../../components/inputs/EASelectInput";
import { useFieldArray, useFormContext } from "react-hook-form";
import { isEmpty, find } from "lodash";
import { uniqWith } from "lodash";
import useStyles from "../DossiersListSearchFormStyle";
import { SearchFormInputBloc } from "components/lists-advanced-search/SearchFormInputBloc/SearchFormInputBloc";
import { CalculationResultType } from "services/common/CalculatorUtils";
import i18next from 'i18next';

const getCalculationOptions = (calculation) => {
  return CalculationResultType.ARITHMETIC_FORMULA_OUTPUT === calculation?.resultType ?
    []
    :
    uniqWith(calculation?.branches, (a, b) => a.resultValue === b.resultValue)
      .sort((a, b) => {
        if (b.default) return -1;
        if (a.default) return 1;
        return a.resultValue.localeCompare(b.resultValue)
      })
      .map((x) => ({
        value: x.resultValue,
        label: x.resultValue,
      }))
};

export const DossiersSearchCalculatedAttributes = ({
  calculation,
  fieldName
}) => {
  return (
    <Grid item xs={3}>
      <SearchFormInputBloc label={calculation?.name} hasTooltip>
        <EASelectInput
          fieldName={fieldName}
          options={getCalculationOptions(calculation)}
          defaultOption={i18next.t('all')}
        />
      </SearchFormInputBloc>
    </Grid>
  );
};

export const DossiersSearchIndicators = ({ indicators, lineIndex }) => {
  const { classes } = useStyles();
  const formMethods = useFormContext();

   const { fields: indicatorsFields, append: indicatorsAppend } = useFieldArray({
      control: formMethods.control,
      name: `dossiers.${lineIndex}.indicators`,
    });

  useEffect(() => {
    if (isEmpty(indicatorsFields)) {
      indicators?.sort((a, b) => a.name.localeCompare(b.name))?.forEach((calc) => {
        indicatorsAppend({ 
          id: calc.name,
            values: "",
            type: "indicators",
            name: calc.name 
          });
      });
    }
  }, [indicators, indicatorsFields, indicatorsAppend]);

  return (
    !isEmpty(indicators) && (
      <>
        <Divider className={classes.advancedSearchDivider} style={{ marginBottom: 0 }} />
        {indicatorsFields.map((field, index) => {
          const calculation = find(indicators, { name: field.name });
          return calculation && (
            <Grid item xs={3} key={field.id}>
              <SearchFormInputBloc label={calculation.name} hasTooltip>
                <EASelectInput
                  fieldName={`dossiers.${lineIndex}.indicators.${index}.values`}
                  options={getCalculationOptions(calculation)}
                  defaultOption={i18next.t('all')}
                />
              </SearchFormInputBloc>
            </Grid>
          );
        })}
      </>
    )
  );
};
